import React, { forwardRef } from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

import BlogLadyCTA from '../../../assets/images/blog/blog-cta-lady.jpg'
import { colors, fontSize } from '../../../style/design-system'

const FormCTA = forwardRef(({ className }, ref) => {
  const scrollToForm = () => {
    const blogForm = document.getElementById('blog-form')
    window.scrollTo({
      top: blogForm.offsetTop - 50,
      left: 0,
      behavior: 'smooth',
    })
  }

  return (
    <div className={`${className} text-center my-6 p-7 p-lg-8`} ref={ref}>
      <img src={BlogLadyCTA} alt="" />
      <h2 className="h1 blue text-center">Discover a new career path&nbsp;today!</h2>
      <h3 className="mt-0 text-center">Learn How We Can Help You&nbsp;Succeed</h3>
      <button className="mt-4 w-75 white p-4 mt-md-6" onClick={scrollToForm}>Request&nbsp;Info</button>
    </div>
  )
})

FormCTA.propTypes = {
  className: PropTypes.string,
}

export default styled(FormCTA)`
  background-color: ${colors.umaLightGray};
  button {
    font-size: ${fontSize.e};
    font-weight: bold;
    background-color: ${colors.umaGreen};
    border: none;
  }
`
